import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { putRequest } from '../../../requestUtils';
var ProjectFeedback = /*#__PURE__*/function (_Component) {
  function ProjectFeedback(props) {
    var _this;
    _classCallCheck(this, ProjectFeedback);
    _this = _callSuper(this, ProjectFeedback, [props]);
    _this.state = {
      isReadingMore: false,
      showReadMore: false,
      edit: false,
      note: props.note
    };
    _this.readMore = _this.readMore.bind(_this);
    _this.handleEdit = _this.handleEdit.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    return _this;
  }
  _inherits(ProjectFeedback, _Component);
  return _createClass(ProjectFeedback, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setShowReadMore();
    }
  }, {
    key: "handleEdit",
    value: function handleEdit() {
      var edit = this.state.edit;
      this.setState({
        edit: !edit
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      this.setState({
        note: target.value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var note = this.state.note;
      var _this$props = this.props,
        resourceId = _this$props.resourceId,
        csrfToken = _this$props.csrfToken,
        handleUpdateFeedback = _this$props.handleUpdateFeedback,
        feedback = _this$props.feedback;
      putRequest("/projects/".concat(resourceId, "/project_feedbacks/").concat(feedback.id), {
        project_feedback: {
          note: note
        }
      }, csrfToken).then(function () {
        _this2.setState({
          edit: false,
          note: note
        });
        handleUpdateFeedback(feedback, note);
        _this2.setShowReadMore();
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        edit: false
      });
    }
  }, {
    key: "readMore",
    value: function readMore() {
      this.setState({
        isReadingMore: !this.state.isReadingMore
      });
    }
  }, {
    key: "renderEdit",
    value: function renderEdit(feedback, canEdit) {
      if (canEdit) {
        return /*#__PURE__*/React.createElement("span", {
          className: "body-text-3"
        }, /*#__PURE__*/React.createElement("a", {
          tabIndex: 0,
          role: "button",
          onClick: this.handleEdit
        }, "Edit"));
      }
      return null;
    }
  }, {
    key: "renderNote",
    value: function renderNote() {
      var _this3 = this;
      var _this$state = this.state,
        isReadingMore = _this$state.isReadingMore,
        edit = _this$state.edit,
        note = _this$state.note;
      var feedback = this.props.feedback;
      if (edit) {
        return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
          className: "fs-hide form-group"
        }, /*#__PURE__*/React.createElement("textarea", {
          value: note,
          className: "form-control note body-text-3",
          placeholder: "Add a comment...oooo",
          name: "note",
          id: "edit-note",
          rows: "3",
          onChange: function onChange(e) {
            return _this3.handleInputChange(e);
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "align mb-2"
        }, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-secondary-no-border end cancel-project-comment-update",
          type: "button",
          onClick: function onClick() {
            return _this3.handleCancel();
          }
        }, "Cancel"), /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary end update-project-comment ms-3",
          type: "button",
          onClick: function onClick() {
            return _this3.handleSubmit();
          }
        }, "Update")));
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this3.notesElement = el;
        },
        className: "comment ".concat(isReadingMore ? 'show' : 'overflow')
      }, feedback.note), this.renderDateAndReadMore());
    }
  }, {
    key: "renderDateAndReadMore",
    value: function renderDateAndReadMore() {
      var _this$state2 = this.state,
        isReadingMore = _this$state2.isReadingMore,
        showReadMore = _this$state2.showReadMore,
        edit = _this$state2.edit;
      var feedback = this.props.feedback;
      if (feedback.note && showReadMore && !edit) {
        return /*#__PURE__*/React.createElement("div", {
          className: "align"
        }, /*#__PURE__*/React.createElement("a", {
          className: "body-text-4",
          tabIndex: 0,
          role: "link",
          onClick: this.readMore
        }, ' ', isReadingMore ? 'Read Less' : 'Read More'), /*#__PURE__*/React.createElement("span", {
          className: "body-text-4 end no-wrap muted-gray-text"
        }, feedback.string_note_created_at));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "align"
      }, /*#__PURE__*/React.createElement("span", {
        className: "body-text-4 end no-wrap muted-gray-text"
      }, feedback.string_note_created_at));
    }
  }, {
    key: "setShowReadMore",
    value: function setShowReadMore() {
      // Added 1 to clientHeight because in Safari 12.1 there is a rounding error leading
      // scrollHeight to be bigger than the clientHeight by 1 and so showReadMore is true
      this.setState({
        showReadMore: this.notesElement.scrollHeight > this.notesElement.clientHeight + 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        feedback = _this$props2.feedback,
        displayName = _this$props2.displayName,
        canEdit = _this$props2.canEdit,
        email = _this$props2.email;
      var identifier = feedback.name || feedback.email;
      return /*#__PURE__*/React.createElement("div", {
        className: "feedback project-feedback body-text-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-between"
      }, /*#__PURE__*/React.createElement("span", {
        className: "fs-hide demibold body-text-3"
      }, (displayName || canEdit) && (email === feedback.email ? 'You' : identifier)), this.renderEdit(feedback, canEdit)), this.renderNote());
    }
  }]);
}(Component);
ProjectFeedback.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  feedback: PropTypes.shape({
    string_note_created_at: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.number
  }).isRequired,
  handleUpdateFeedback: PropTypes.func.isRequired,
  note: PropTypes.string.isRequired,
  displayName: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired
};
export default ProjectFeedback;